<div
    class="flex"
    [style.height]="executorList ? '100%' : '115px'"
>

    <div class="status" [ngClass]="setStatusColor(task.data.status)" [style.width.px]="smallWidth ? '10' : '4'" data-testid="task-card-status-div"></div>

    <div class="task pdl-0-3 flex-column radius overflow-hidden w-100 p-relative" cdkDrag [cdkDragDisabled]="authService.isExecutor()" [cdkDragData]="task"
         (mousedown)="onMouseDown($event)"
         (mouseup)="onMouseUp()"
         (cdkDragEnded)="onDragEnded()"
         (cdkDragStarted)="dragStarted()"
         (mousemove)="onMouseMove($event)"
    >
            @if (smallWidth) {
                <div class="vertical">
                    <span data-testid="small-task-card-id-span">{{ task.data.id }}</span>
                    <b class="work-time">{{totalDuration || 20}}м</b>
                </div>
            }

        @if(authService.isAdmin() || authService.isManager()) {
            <div class="p-absolute select" [class.selected]="task.data.selected">
                <mat-icon class="select-icon">
                    check_circle
                </mat-icon>
            </div>
        }

        @if (!smallWidth) {
            <div class="task-header flex j-space-between a-center">
                <div>
                    <span id="order-id" data-testid="task-card-id-span">Заявка №{{ task.data.id }}</span>
                </div>

                @if (authService.isAdmin() || authService.isManager()) {
                    <button mat-icon-button (click)="showInfo($event, task.data.id)" matTooltip="Подробнее">
                        <mat-icon>info</mat-icon>
                    </button>
                }
            </div>

            <div class="time flex-column">
                <strong>{{ task.data.dateFrom | date:'HH:mm' }}-{{ task.data.dateTo  | date:'HH:mm' }}</strong>
                <span>{{totalDuration || 20}} мин</span> <!--Если суммарное время работ = 0 заказчик попросил ставить 20мин -->
            </div>

            <div class="flex-column pdr-1 pdl-1">
                @if (task.data.location) {
                    <span class="address" data-testid="task-card-address-span">{{ shortAddress(task.data.location.address) }}</span>
                }

                @if (authService.isExecutor()) {
                    @if (task.data.contact && task.data.contact.phone) {
                        <a class="mrt-1 mrb-0-5 flex a-center" (click)="onLinkClick($event)" [href]="'tel:' + task.data.contact.phone">
                            <mat-icon>phone</mat-icon>
                            {{ task.data.contact.phone }}</a>
                    } @else {
                        Номер не указан
                    }


                } @else if (task.data.contact) {
                    <span data-testid="task-card-phone-number-span">{{ task.data.contact.phone }}</span>
                }
            </div>
        }
<!--        внешний вид при перетягивании -->
        <div *cdkDragPreview class="preview">
            @if (moveOrders.size < 2) {
                Заявка №{{task.data.id}}
            } @else {
                Заявок {{moveOrders.size}}
            }
        </div>

        <!--        отображение на блоке, куда собираемся перетягивать -->
        <div *cdkDragPlaceholder></div>
    </div>
</div>
